import { Navigate } from "react-router-dom";

const GuestRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  // If already logged in → go to dashboard
  if (isLoggedIn) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default GuestRoute;
